import {flow, getRoot, types} from "mobx-state-tree";

import api from "../../../common/api";
import {BetHistoryItem} from "../user/models/bets";
import {betsUpdateTime} from "../../config/timers/user";


export const ActiveCouponPage = types
    .model('ActiveCouponPage', {
        activeCoupon: types.maybeNull(BetHistoryItem),
        isLoading: true,
        error: false,
    })
    .actions((self) => ({
        _set(data) {
            self.activeCoupon.setDetails(data);
        },
        _setError(flag) {
            self.error = flag;
        },
        _setLoading(flag) {
            self.isLoading = flag;
        },
        getCouponDetail: flow(function* fetch({uid}) {
            if (self.activeCoupon?.uid !== uid) {
                self.activeCoupon = BetHistoryItem.create({id: Date.now(), uid});
            }
            api.user.getShopBetDetails({couponNo: getRoot(self).router.currentPageOptions.couponUid}).then(res => {
                if (res.success) {
                    self._setError(false);
                    self._set(res.data);
                    self._setLoading(false);
                    self.setUpdateDetails();
                } else {
                    self._setError(true);
                    self._setLoading(false);
                }
            })
        }),
        stopGettingDetails() {
            self.activeCoupon = null;
            self.isLoading = true;
            clearTimeout(window.__couponDetailsUpdater);
        },
        setUpdateDetails() {
            clearTimeout(window.__couponDetailsUpdater);
            window.__couponDetailsUpdater = setTimeout(
                () => self.getCouponDetail({uid: self.activeCoupon.uid}),
                betsUpdateTime.activeBets.itemFetchTime
            );
        },
    }))